// The Studio's words in Japanese. Same keys and placeholders as en.ts
// (test/i18n.test.ts). Register: です・ます, plain statements; full-width
// 、。「」; one half-width space between Japanese and Latin words or numbers;
// product and game names as they are. Device names: PSP, PS Vita,
// ニンテンドー3DS, iPod touch, Android スマートフォン.

import type { MessageKey } from "./en.ts";

export const JA: Record<MessageKey, string> = {
  "room.back": "部屋に戻る",
  "room.home": "Pocket Studio のホーム",
  "room.loading": "スタジオを開いています",
  "room.hint": "デバイス、ゲーム、ノートパソコン、テレビを選べます。ドラッグすると部屋を見回せます。",
  "room.index": "部屋にあるもの",
  "room.shelf.previous": "前のゲーム",
  "room.shelf.next": "次のゲーム",
  "room.shelf.pages": "ゲーム棚のページ",
  "room.shelf.page": "{pages} ページ中 {page} ページ目",
  "room.closet": "クローゼット",
  "room.settings": "設定",
  "room.account": "アカウント",
  "room.laptop": "ノートパソコン",
  "room.notOpen": "部屋がまだ開いていません。",

  "room.play": "遊ぶ",
  "room.playOn": "{device} で遊ぶ",
  "room.open": "開く",
  "room.download": "{title} の {device} 向けパッケージをダウンロード",
  "room.package.for": "{device} 向け",
  "room.colour.group": "{device} の色",
  "room.colour.locked": "{colour}（メンバー向け）",
  "room.colour.own": "自分で作った色",
  "room.colour.own.locked": "自分で作った色（メンバー向け）",
  "device.lead": "このデバイスで遊ぶゲームを選んでください。",
  "device.empty": "このデバイスで動くゲームは、まだ棚にありません。",
  "closet.lead": "デバイスごとに色を選べます。",
  "closet.own": "自分で作った色 {color}",
  "room.by": "作者: {author}",
  "room.verified": "Pocket Nexus 確認済み",
  "room.remixOf": "{author} の「{title}」のリミックス",
  "room.homebrew": "このゲームのパッケージは作者が配布する自作ソフトです。Pocket Nexus は動作を確認していません。",
  "room.howToInstall": "パッケージのインストール方法",
  "room.remix": "リミックス",
  "room.keep": "自分の棚に置く",
  "room.keep.note": "外すまで、あなたの棚に置かれます。",
  "room.unkeep": "棚から外す",
  "room.kept": "棚に置きました。",
  "room.unkept": "棚から外しました。",
  "room.site.play": "ブラウザで遊ぶ",
  "room.site.empty.verified": "まだ遊べるものがありません。ターミナルからウェブ版とパッケージをアップロードしてください。",
  "room.site.empty": "まだ遊べるものがありません。ターミナルからパッケージをアップロードしてください。",
  "room.noBuild": "まだビルドがありません。",
  "room.copy": "コピー",
  "room.copied": "コピーしました",
  "room.save": "保存",
  "room.title": "タイトル",
  "room.address": "アドレス",
  "room.address.change": "アドレスを変更",
  "room.address.failed": "アドレスを変更できませんでした。もう一度お試しください。",
  "room.takedown": "このゲームは Pocket Nexus により公開停止になりました",
  "room.takedown.body": "棚とアドレスから外れていて、停止が解除されるまで公開できません。{email} までご連絡ください。",
  "room.publish": "公開する",
  "room.publish.note": "アドレスを知っている人なら誰でも遊べます。公開はあとで取り下げられます。",
  "room.unpublish": "公開をやめる",
  "room.members.download": "ダウンロードを許可",
  "room.packages": "パッケージ: {list}",
  "room.homebrew.own": "プレイヤーには、Pocket Nexus が動作を確認していない自作ソフトとして表示されます。",
  "room.notDiscoverable": "Pocket TV と検索には出ていません。メンバーのゲームは出ます。",
  "room.rename": "名前を変更",
  "room.rename.failed": "名前を変更できませんでした。もう一度お試しください。",
  "room.delete": "このゲームを削除",
  "room.delete.confirm": "完全に削除する",
  "room.delete.keep": "残しておく",
  "room.delete.failed": "削除できませんでした。もう一度お試しください。",
  "room.changeFailed": "変更できませんでした。",

  "play.title": "プレイ中",
  "play.lead.both": "キー、本体のボタンのクリック、画面のタッチで操作します。",
  "play.lead.touch": "ポインターで画面をタッチして操作します。",
  "play.lead.keys": "キーか、本体のボタンのクリックで操作します。",
  "keys.arrows": "矢印キー",
  "keys.dpad": "方向キー",
  "keys.space": "スペース",
  "keys.leftRight": "← / →",
  "keys.circle": "○",
  "keys.cross": "×",
  "keys.squareTriangle": "□ / △",


  "tv.lead": "みんなが作っているゲームを、1 本ずつ紹介します。",
  "tv.previous": "前へ",
  "tv.next": "次へ",
  "tv.open": "このゲームを開く",
  "tv.soundOn": "音を出す",
  "tv.soundOff": "音を消す",
  "tv.change": "ゲームを切り替える",
  "tv.openIt": "開く",

  "agent.linking": "リンクコードを作っています",
  "agent.linkFailed": "リンクコードを作れませんでした。もう一度お試しください。",
  "remix.title": "{title} をリミックス",
  "remix.prompt": "ゲーム「{title}」（{page}）をリミックスして、自分のゲームにしてください。\n\n1. ソースをサブモジュールごとクローンする: {repository}\n2. README.md と AGENTS.md を読み、このコンピューターでビルドして動かす。\n3. 変えたいところ: {game}\n\nPocket Studio での公開を頼んだときは、{guide} に従ってください。",
  "remix.prompt.pocket": "Pocket Studio のゲーム「{title}」（{page}）をリミックスして、自分のゲームにしてください。\n\n1. これは PocketJS アプリで、ソースは Pocket Studio が保管しています。{guide} に従ってこのコンピューターを準備し、私のアカウントにつないでください。リンクコードは私に聞いてください。\n2. ゲームをコピーする: pocket-studio remix {id}\n3. 変えたいところ: {game}",

  "wall.make": "ログインするとアプリを作れます。部屋とアプリはそのまま引き継がれます。",
  "gate.title": "スタジオの準備ができました",
  "gate.lead": "ログインすると、部屋とゲームを残しておけます。",

  "toast.noBuild": "このゲームには、まだどのデバイス向けのビルドもありません。",
  "toast.noBuildHere": "このゲームには、まだこのデバイス向けのビルドがありません。",
  "toast.colourFailed": "色を変更できませんでした。",
  "toast.roomMembers": "{room} はメンバーシップで使えます。",
  "toast.roomMembers.unnamed": "その部屋はメンバーシップで使えます。",
  "toast.roomFailed": "部屋を変更できませんでした。",
  "toast.downloading": "{title} の {device} 向けパッケージをダウンロードしています。",
  "toast.downloading.unnamed": "{device} 向けのゲームをダウンロードしています。",
  "toast.downloadUnavailable": "このダウンロードは利用できません。",
  "toast.startFailed": "ゲームを開始できませんでした。",
  "checkout.success": "ありがとうございます。メンバーシップを開始しています。",
  "checkout.member": "メンバーになりました。すべての色を使えます。",
  "checkout.member.page": "メンバーになりました。過去のバージョンをダウンロードできます。",
  "checkout.cancelled": "支払いは完了していません。料金は請求されていません。",

  "oauth.title": "{client} を接続",
  "oauth.lead": "{client} が {who} として Pocket Studio を使おうとしています。アカウントの確認、アプレットの作成と削除、クレジットの使用、ゲームの公開ができます。",
  "oauth.back": "このあと {host} に戻ります。",
  "oauth.allow": "接続する",
  "oauth.deny": "キャンセル",
  "oauth.signin": "{client} を Pocket Studio に接続するには、ログインしてください。",
  "oauth.failed": "接続できませんでした。もう一度お試しください。",
  "oauth.bad.title": "このリンクでは接続できません",
  "oauth.connected": "接続中のエージェント",
  "oauth.connected.lead": "これらはあなたとして Pocket Studio を使えます。接続を解除すると、もう一度許可が必要になります。",
  "oauth.connected.none": "接続中のものはありません。",
  "oauth.connected.remove": "接続を解除",
  "oauth.connected.used": "最終利用日 {date}",
  "oauth.connected.signin": "接続中のものを確認するには、ログインしてください。",
  "account.join": "メンバーになる",
  "account.manage": "メンバーシップの管理",
  "account.portalFailed": "メンバーシップのページを開けませんでした。もう一度お試しください。",
  "account.keep": "この部屋とゲームをアカウントに残します。",
  "account.leave": "退出する",
  "account.signOut": "ログアウト",
  "account.guest": "ゲスト",
  "account.plan": "プラン",
  "account.handle": "ハンドル",
  "account.handle.change": "ハンドルを変更",
  "account.handle.rule": "あなたのゲームにはこの名前が表示されます。小文字の英字、数字、ハイフンを使い、3〜24 文字にしてください。",
  "account.handle.failed": "ハンドルを変更できませんでした。もう一度お試しください。",
  "plan.free": "無料",
  "plan.member": "メンバー",
  "plan.until": "メンバー（{day} まで）",
  "plan.renews": "メンバー（{day} に更新）",
  // 特典によるメンバーシップと、特典を受け取るページ（src/ui/account.ts, src/core/offers.ts）。
  "plan.life": "永久メンバー",
  "account.grantRenews": "永久メンバーですが、サブスクリプションの更新が続いています。「メンバーシップの管理」から解約できます。",
  "offer.label": "特典",
  "offer.signIn": "この特典を受け取るにはログインしてください。",
  "offer.gives.life": "永久メンバーシップが付与されます。",
  "offer.gives.days": "{days} 日間のメンバーシップが付与されます。",
  "offer.ready.github": "あなたの Pocket Studio アカウントに連携された GitHub アカウントは、この特典の対象です。",
  "offer.ready.code": "受け取ったコードを入力してください。",
  "offer.claim": "受け取る",
  "offer.connect": "この特典は対象リストにある GitHub アカウント向けです。確認のため、GitHub アカウントを Pocket Studio アカウントに連携してください。",
  "offer.connect.button": "GitHub を連携",
  "offer.notListed": "Pocket Studio アカウントに連携された GitHub アカウントは、この特典の対象リストにありません。",
  "offer.used": "これは別の Pocket Studio アカウントで受け取り済みです。",
  "offer.code": "コード",
  "offer.wrongCode": "そのコードはこの特典の対象リストにありません。",
  "offer.closed": "この特典は終了しました。",
  "offer.granted.life": "あなたのアカウントは永久メンバーになりました。ありがとうございます。",
  "offer.granted.until": "あなたのアカウントは {day} までメンバーです。",
  "offer.missing": "この特典は見つかりません。",
  "offer.failed": "特典を読み込めませんでした。もう一度お試しください。",
  "offer.linkedElsewhere": "その GitHub アカウントは別の Pocket Studio アカウントに連携されています。そのアカウントでサインインして特典を受け取ってください。",
  "offer.linkFailed": "GitHub の連携を開始できませんでした。もう一度お試しください。",
  "offer.done": "閉じる",
  "paywall.download": "ダウンロードはメンバー向けです",
  "paywall.colours": "ほかの色はメンバー向けです",
  "paywall.plan": "プラン",
  "paywall.perMonth": "月額 {price}",
  "paywall.yearly": "年 1 回 {price} のお支払い",
  "paywall.monthly": "毎月のお支払い",
  "paywall.terms": "解約するまで更新されます。解約はアカウントメニューの「メンバーシップの管理」からでき、解約後も支払い済みの期間の終わりまで使えます。{terms}と{privacy}をご確認ください。",
  "paywall.go": "支払いに進む",
  "paywall.signIn": "メンバーシップはアカウントに付きます。部屋とゲームはそのまま引き継がれます。",
  "paywall.closed": "メンバーシップはまだ始まっていません。",
  "paywall.failed": "支払いを開始できませんでした。もう一度お試しください。",
  "paywall.mainland": "中国本土から支払う",
  "paywall.notNow": "今はやめておく",
  "agreement.title": "利用規約の更新",
  "agreement.body": "前回の同意のあとに、Pocket Studio の{terms}に大切な変更がありました。アカウントを使い続けると、現在の版に同意したことになります。情報の扱いについては{privacy}をご覧ください。",
  "agreement.go": "同意して続ける",
  "agreement.failed": "保存できませんでした。もう一度お試しください。",
  "agreement.signOut": "同意せずにログアウト",
  "legal.terms": "利用規約",
  "legal.privacy": "プライバシーポリシー",
  "lang.label": "言語",

  "signin.title": "ログイン",
  "signin.unavailable": "ここではログインできません。",
  "signin.failed": "ログインできませんでした。もう一度お試しください。",
  "signin.email": "メールアドレス",
  "signin.emailPlaceholder": "you@example.com",
  "signin.sendCode": "コードをメールで受け取る",
  "signin.google": "Google で続ける",
  "signin.github": "GitHub で続ける",
  "signin.guest": "ゲストとして見て回る",
  "signin.code": "6 桁のコード",
  "signin.sent": "{email} にコードを送りました。有効期限は 5 分です。",
  "signin.newest": "{email} に送った最新のコードを入力してください。",
  "signin.otherAddress": "別のアドレスを使う",
  "signin.terms": "続けると、{terms}に同意したことになります。情報の扱いについては{privacy}をご覧ください。",
  "signin.offline": "スタジオにつながりませんでした。ネットワークの接続を確かめてください。",
  "signin.tooMany": "試した回数が多すぎます。1 分ほど待ってから、もう一度お試しください。",
  "signin.wrongCode": "コードが違います。",
  "signin.codeExpired": "コードの有効期限が切れました。新しいコードを受け取ってください。",
  "signin.tooManyCodes": "違うコードが何度も入力されました。新しいコードを受け取ってください。",
  "signin.badEmail": "メールアドレスの形になっていません。",

  "palette.field": "{device}: 彩度と明るさ。矢印キーで調整できます。",
  "palette.hue": "{device}: 色相",
  "palette.code": "{device}: カラーコード",

  "touch.hint": "{screen}はタッチ操作に対応していません。{instead}",
  "touch.screen": "{device} の画面",
  "touch.upper": "{device} の上画面",
  "touch.lower": "{device} の下画面",
  "touch.useLower": "下画面をタッチするか、キーで操作してください。",
  "touch.useUpper": "上画面をタッチするか、キーで操作してください。",
  "touch.useKeys": "キーで操作してください。",


  "landing.page.title": "Pocket Studio: 手に持つ画面のために",
  "landing.og.image": "https://studio.pocket.nexus/assets/og-ja.jpg",
  "landing.og.alt": "手に持つ画面のために。Pocket Studio で作ったものが動く2台のデバイス。",
  "landing.title.html": "手に持つ<span>画面のために。</span>",
  "landing.lede": "Pocket Studio は短い言葉から、MCU でも動く Pocket Applet と、携帯機向けのネイティブな Pocket3D ゲームを作ります。どれも実機で動きます。",
  "landing.lede.html": "Pocket Studio は短い言葉から、MCU でも動く <b>Pocket Applet</b> と、携帯機向けのネイティブな <b>Pocket3D</b> ゲームを作ります。どれも実機で動きます。",
  "landing.prompt.example": "次の5時間がわかる、机に置く天気ボード",
  "landing.prompt.note": "無料で試せます。",
  "landing.shelf": "ゲーム",
  "landing.made.html": "携帯機向けのネイティブゲームです。多くは機種ごとにコンパイルされた <a href=\"https://3d.pocket.nexus/\">Pocket3D</a> の世界です。ここで遊ぶことも、自分の機種に入れることもできます。",
  "landing.room.title": "自分の部屋で作る",
  "landing.room.text": "ブラウザの中の小さな部屋で作ります。エージェントに作りたいものを伝え、できた版を会話の横の画面で試し、気に入ったらダウンロードします。待つあいだは携帯機を手に取って遊べます。",
  "landing.room.alt": "Studio の部屋。左にエージェントとの会話、その横に Tab5 の画面で動く、作られたアプリ。",
  "shelf.native": "ネイティブゲーム",
  "shelf.mod": "MOD",
  "landing.prompt.label": "どんなアプリにしますか",
  "landing.prompt.games": "ゲームを遊ぶ",
  "landing.open": "スタジオを開く",
  // The row of device chips on a card of the shelf: what the row is, and the chip for a desktop computer.
  "shelf.on": "対応機種",
  "shelf.desktop": "デスクトップ",
  "landing.mods.what": "Pocket Voxel と OpenStrike は MOD です。手持ちのゲームのファイルを読み込んで動くので、ここではデモとして紹介しています。コードは公開しているので、持ち帰って自分のものにしてください。",
  "mods.voxel.line": "ゲームボーイのモンスター育成 RPG をボクセルのジオラマにしたもの。自分の ROM からビルドします。",
  "mods.voxel.what": "Pocket Voxel は、ゲームボーイのモンスター育成 RPG の町や部屋や道をボクセルのジオラマとして作り直し、その中でゲームを遊べるようにしたものです。",
  "mods.voxel.how": "バトル、スクリプト、メニュー、セーブといったゲームの状態は、PocketJS のゲストである QuickJS の上で動く TypeScript が持っています。Rust のコアが持つのはシーンだけで、ボクセルのチャンク、スプライト、カメラです。そのシーンを PSP は GE で、PS Vita は GXM で、それぞれ専用のレンダラーが描きます。",
  "mods.voxel.why": "手持ちのゲームの ROM を読み込んで動き、そこから作ったものはすべて自分のマシンに残ります。ここではデモとして紹介しています。コードは公開しているので、自分でビルドして手を加えられます。",
  "mods.voxel.from": "PSP と同じ 480 × 272 で、このプロジェクトが PSP の画面と照らし合わせているソフトウェアレンダラーが描いた映像です。",
  "mods.strike.line": "クラシックな BSP マップで遊ぶ CS ライクな FPS。マップは自分が持っているゲームのものを使います。",
  "mods.strike.what": "OpenStrike は、クラシックな BSP マップの上でボットとラウンドを戦う一人称シューティングです。",
  "mods.strike.how": "ラウンドのルール、武器の性能表、ボットの強さ、HUD 全体は QuickJS の上で動く JavaScript で、HUD は JSX で書かれています。Rust のコアがワールドをシミュレーションし、マシンごとのレンダラーで描きます。PSP は GE、PS Vita は GXM、デスクトップ PC は wgpu です。",
  "mods.strike.why": "マップとテクスチャを手持ちのゲームから読み込み、自分のマシンで変換します。ここではデモとして紹介しています。コードは公開しているので、自分でビルドして手を加えられます。",
  "mods.strike.from": "PSP 版をエミュレーターで動かし、480 × 272 で 1 フレームずつ記録した映像です。",
  "mods.source": "GitHub でソースを見る",
  "mods.close": "閉じる",

  "games.title": "ゲーム",
  "games.lede": "棚に並ぶすべてのゲームです。各ゲームのページに、映像、デバイスごとのダウンロード、ソースがあります。",
  "games.none": "棚にはまだゲームがありません。",

  "foot.elsewhere": "関連リンク",
  "foot.mcp": "MCP",
  "foot.docs": "ドキュメント",
  "foot.guide": "インストールガイド",
  "foot.credits": "クレジット",
  "foot.terms": "利用規約",
  "foot.privacy": "プライバシー",
  "foot.marks": "PlayStation、PSP、PS Vita は株式会社ソニー・インタラクティブエンタテインメントの商標です。ニンテンドー3DS とゲームボーイは任天堂の商標です。iPod touch は Apple Inc. の商標です。Android と YouTube は Google LLC の商標です。X、Discord、Hacker News、M5Stack、Tab5 はそれぞれの所有者に帰属します。Pocket Nexus はこれらの企業と提携しておらず、後援や承認も受けていません。",

  "credits.title": "クレジット",
  "credits.devices": "デバイス",
  "credits.psp.html": "PSP のモデル: <a href=\"https://sketchfab.com/3d-models/playstation-portable-psp-eg02-b76c7f9158204a39929a9c97d0b813d0\">Dibad</a> による「PlayStation Portable (PSP) - EG02」、<a href=\"https://creativecommons.org/licenses/by/4.0/\">CC BY 4.0</a>。PocketJS が軽量化し、ここではロゴと商標の文字を除いて描いています。<a href=\"/devices/psp/ATTRIBUTION.md\">詳細</a>。",
  "credits.vita.html": "PS Vita とニンテンドー3DS のモデル: <a href=\"https://pocketjs.pocket.nexus/\">PocketJS</a> のために作られたものです。PS Vita はロゴと商標の文字を除いて描いています。<a href=\"/devices/vita/ATTRIBUTION.md\">PS Vita</a>、<a href=\"/devices/3ds/ATTRIBUTION.md\">3DS</a>。",
  "credits.ipod.html": "iPod touch のモデル: Pocket Studio のために作られたものです。<a href=\"/devices/ipod-touch/ATTRIBUTION.md\">詳細</a>。",
  "credits.android.html": "Android スマートフォンのモデル: Pocket Studio のために、特定のメーカーの機種に寄せずに作られたものです。<a href=\"/devices/android/ATTRIBUTION.md\">詳細</a>。",
  "credits.marks": "PlayStation、PSP、PS Vita は株式会社ソニー・インタラクティブエンタテインメントの商標です。ニンテンドー3DS は任天堂の商標です。iPod touch は Apple Inc. の商標です。Android は Google LLC の商標です。モデルはエミュレーションのために実機の形を表したもので、部屋にはこれらの企業のロゴを描いていません。Pocket Nexus はこれらの企業と提携しておらず、後援や承認も受けていません。",
  "credits.agents": "エージェント",
  "credits.agents.text": "作業台の 2 体のフィギュアは、コマンドラインツールが起動できるコーディングエージェントを表しています。Claude と Claude Code は Anthropic の商標です。Codex は OpenAI の商標です。Pocket Studio はどちらの企業とも提携していません。",
  "credits.software": "ソフトウェア",
  "credits.pocketjs.html": "<a href=\"https://pocketjs.pocket.nexus/\">PocketJS</a> がすべてのゲームとノートパソコンを動かしています。MIT ライセンス。",
  "credits.shell.html": "<a href=\"https://github.com/pocket-nexus/pocket-shell\">Pocket Shell</a> はノートパソコンのデスクトップです。GPL-3.0。",
  "credits.three.html": "<a href=\"https://threejs.org/\">three.js</a> が部屋を描いています。MIT ライセンス。",
  "credits.type": "書体",
  "credits.fonts.html": "Naipe Foundry の Gabarito と IBM の IBM Plex を、このサイトから配信しています。どちらも SIL Open Font License 1.1 のもとで使っています: <a href=\"/assets/fonts/Gabarito-OFL.txt\">Gabarito</a>、<a href=\"/assets/fonts/IBM-Plex-OFL.txt\">IBM Plex</a>。",
  "credits.noto.html": "日本語の見出しは Google と Adobe の Noto Sans JP で組んでいます。このサイトのページが使う文字だけを、SIL Open Font License 1.1 のもとでこのサイトから配信しています: <a href=\"/assets/fonts/Noto-Sans-JP-OFL.txt\">Noto Sans JP</a>。",
  "credits.titan": "部屋のネオンサイン、ポスター、テレビのバッジの文字は Rodrigo Fuenzalida の Titan One で、同じライセンスのもとで使っています。",

  "notFound.title": "ページが見つかりません",
  "notFound.heading": "そのページはこの部屋にありません",
  "notFound.back": "Pocket Studio に戻る",

  "legal.termsTitle": "利用規約",
  "legal.privacyTitle": "プライバシーポリシー",
  "legal.meta": "最終更新日: {date}。{other}もあわせてご覧ください。",
  "guide.title": "インストールガイド",

  "game.by": "作者: {author}。",
  "game.fallback": "Pocket Studio のゲーム「{title}」。",
  "game.imageAlt": "{title} の画像。",
  "game.verified": "Pocket Nexus 確認済み。",
  "game.homebrew": "このゲームのパッケージは作者が配布する自作ソフトです。Pocket Nexus は動作を確認していません。",
  "game.open": "Pocket Studio で開く",
  "game.copy": "リンクをコピー",
  "game.copied": "コピーしました",
  "game.post": "X にポスト",
  "game.shows": "動画と画像",
  "game.clip": "動画 {n}/{count}: {caption}",
  "game.picture": "画像 {n}/{count}: {caption}",
  "game.cover": "{title} のカバー画像。",
  "game.download": "{device} 用をダウンロード",
  "game.source.browser": "ブラウザ版から録画しました。",
  "game.source.device": "{device} 版から取り込みました。",
  "game.note.browser": "この動画と画像はブラウザ版から録画しました。デバイスはそれぞれ専用のレンダラーでゲームを描くので、実機の画面とは見た目が異なります。",
  "game.note.devices": "この動画と画像は、各デバイス向けのビルドから取り込みました。",
  "game.note.mixed": "デバイスはそれぞれ専用のレンダラーでゲームを描くので、実機の画面はブラウザ版と見た目が異なります。",

  // ゲームが提供するもの: プレイ、ダウンロード、リミックス。
  "act.play": "プレイ",
  "act.download": "ダウンロード",
  "act.remix": "リミックス",
  "act.play.of": "{title} をブラウザで遊ぶ",
  "act.download.of": "{title} をダウンロード",
  "act.remix.of": "{title} をリミックス",
  "get.heading": "ダウンロード",
  "get.title": "{title} をダウンロード",
  "get.devices": "お使いのデバイス用",
  "get.source": "ソースコード",
  "get.source.zip": "{host} から ZIP で",
  "get.source.repo": "{host} のリポジトリ",
  "get.source.archive": "ソースのアーカイブ",
  "get.source.note": "ここのパッケージはすべてこのソースからビルドされています。リミックスもここから始まります。",
  "get.version": "バージョン {version}",
  "get.free": "Pocket Studio のアカウントがあれば無料です。",
  "get.guide": "インストールガイド",
  "get.none": "このゲームには、まだダウンロードできるパッケージがありません。",
  "get.versions": "すべてのバージョン",
  "get.versions.note": "過去のバージョンはメンバーシップの特典です。",
  "get.signin": "{device} 用の {title} をダウンロードするには、ログインしてください。無料です。",
  "get.signin.source": "{title} のソースをダウンロードするには、ログインしてください。無料です。",
  "get.started": "{device} 用の {title} をダウンロードしています。",
  "get.started.source": "{title} のソースをダウンロードしています。",
  "get.again": "もう一度ダウンロード",
  "get.back": "ゲームに戻る",
  "get.close": "閉じる",
  "versions.title": "{title} のすべてのバージョン",
  "versions.current": "現在",
  "versions.none": "過去のバージョンはまだありません。このゲームが更新されると、それまでのバージョンがここに残ります。",
  "versions.member": "過去のバージョンはメンバーシップの特典です。",
  "versions.signin": "{title} の過去のバージョンを入手するには、ログインしてください。",
  "paywall.versions": "過去のバージョンはメンバー向けです",
  "remix.page.lead": "これをコーディングエージェントに貼り付けてください。エージェントがゲームをあなたのコンピューターにコピーし、あなたのゲームに作り変えます。",
  "remix.any": "変えたいところを書いてから送信してください。Claude Code、Codex、Cursor など、コンピューターでコマンドを実行できるコーディングエージェントなら、どれでも使えます。",
  "remix.publish": "Pocket Studio で公開する",
  "remix.publish.text": "リミックスには専用のページができ、このゲームのページの「リミックス」にも表示されます。公開はエージェントに頼んでください。エージェントがリンクコードを尋ねます。",
  "remix.publish.pocket": "ゲームをコピーするときに、エージェントがリンクコードを尋ねます。リミックスを公開すると専用のページができ、このゲームのページの「リミックス」にも表示されます。",
  "remix.code": "リンクコードを取得",
  "remix.code.note": "このコードをエージェントに伝えてください。あなたのコンピューターの pocket-studio コマンドを、15 分以内に 1 回だけ、あなたのアカウントにつなぎます。",
  "remix.signin": "リンクコードを取得するには、ログインしてください。無料です。",
  "remix.guide": "リミックスの公開方法",
  "remix.code.title": "リンクコード",
  "remix.guide.pocket": "リミックスガイド",
  "remix.engine": "GitHub の Pocket3D",
  "game.remixOf": "{author} の {game} のリミックスです。",
  "game.remixes": "リミックス",
  "game.remixes.more": "ほかに {count} 件あります。",
  "game.remix.by": "作者: {author}",
  "game.remix.browser": "ブラウザで遊べます",
  "feed.label": "ほかのゲーム",
  "feed.next": "次のゲーム",
  "feed.previous": "前のゲーム",
  "dock.about": "{title} について",

  "play.made": "Pocket Studio で作られたゲーム",
  "play.without": "{title} は {author} による PocketJS アプリで、{devices} 向けに作られています。ダウンロードできるパッケージはまだありません。",
  "play.without.alone": "{title} は {author} による PocketJS アプリです。ダウンロードできるパッケージはまだありません。",
  "play.about": "これは PocketJS のウェブプレイヤーです。",
  "play.missing": "このゲームはここにはありません。",
  "play.noBuild": "このゲームには、まだ遊べるビルドがありません。",
  "play.failed": "ゲームを開始できませんでした。",
  "play.stopped": "ゲームが止まりました。再読み込みすると、もう一度始まります。",

  "host.open": "Pocket Studio を開く",
  "host.openIt": "Pocket Studio で開く",
  "host.by": "作者: {author}",
  "host.none.title": "ここにゲームはありません",
  "host.none": "このアドレスで公開されているゲームはありません。",
  "host.missing.title": "ページが見つかりません",
  "host.missing": "{title} には、このアドレスのページがありません。",
  "host.empty.title": "まだ何もありません",
  "host.empty": "{title} にはまだウェブ版がありません。",

  "mail.subject": "Pocket Nexus のログインコード",
  "mail.text": "ログインコードは {otp} です。有効期限は 5 分です。",
  "mail.html": "<p>ログインコードは <strong>{otp}</strong> です。</p><p>有効期限は 5 分です。</p>",

  "codes.address": "このアドレスには {minutes} 分間に {count} 回コードを送りました。最新のコードを使うか、{wait}後にもう一度お試しください。",
  "codes.day": "このアドレスには 1 日に {count} 回コードを送りました。{wait}後にもう一度お試しください。",
  "codes.network": "このネットワークからのコードの要求が多すぎます。{wait}後にもう一度お試しください。",
  "codes.wait.minute": "1 分",
  "codes.wait.minutes": "{n} 分",
  "codes.wait.hours": "約 {n} 時間",

  "api.title.text": "タイトルは文字で入力してください",
  "api.title.length": "タイトルは 1〜60 文字にしてください",
  "api.takenDown": "このゲームは Pocket Nexus により公開停止になっています。停止が解除されるまで公開できません。{email} までご連絡ください。",
  "api.publish.site": "公開する前に、ウェブ版をデプロイするか、パッケージをアップロードしてください",
  "api.publish.package": "公開する前に、パッケージをアップロードしてください",
  "api.publish.build": "公開する前に、ビルドをアップロードしてください",
  "api.guest.address": "ゲームにアドレスを付けるには、アカウントでログインしてください",
  "api.guest.handle": "ハンドルを選ぶには、アカウントでログインしてください",
  "api.app.notFound": "ゲームが見つかりません",
  "api.app.published": "公開されているゲームが見つかりません",
  "api.session.notFound": "セッションが見つかりません",
  "api.signInFirst": "先にログインしてください",
  "api.busy": "混み合っています。もう一度お試しください。",
  "api.rooms.soon": "ほかの部屋は近日公開です。",
  "api.download.off": "作者がパッケージのダウンロードを許可していません",
  "api.download.none": "作者はこのデバイス向けのパッケージをまだアップロードしていません",
  "api.remix.no": "このゲームはリミックスできません",
  "api.remix.noSource": "リミックス元のゲームにソースがありません",
  "api.projects.limit": "1 つのアカウントで持てるプロジェクトは {max} 個までです。新しく作るには、どれか 1 つを削除してください。",
  "api.slug.length": "アドレスは {min}〜{max} 文字です",
  "api.slug.chars": "アドレスには小文字の英字と数字を使い、その間に 1 つずつハイフンを入れられます",
  "api.slug.reserved": "そのアドレスは予約されています",
  "api.slug.taken": "アドレス {slug} はすでに使われています",
  "api.slug.held": "アドレス {slug} は手放されてから {days} 日たっていないため、元のアカウントのために取ってあります",
  "api.handle.length": "ハンドルは {min}〜{max} 文字です",
  "api.handle.chars": "ハンドルには小文字の英字と数字を使い、その間に 1 つずつハイフンを入れられます",
  "api.handle.reserved": "そのハンドルは予約されています",
  "api.handle.taken": "ハンドル {handle} はすでに使われています",

  "api.make.busy": "メーカーはいま混み合っています。クレジットは戻しました。1 分ほどしてからお試しください。",
  "api.make.daily": "今日メーカーが作れる分は終わりました。明日またお試しください。",
  "api.make.credits": "クレジットが足りません。",
  "api.make.guest": "アプリを作るには、アカウントでサインインしてください",
  "api.make.empty": "作りたいものを書いてください",
  "api.make.notFound": "アプリが見つかりません",
  "api.make.noTab5": "Tab5 のアプリ作りはまだ使えません",
  "api.make.tab5Working": "エージェントはまだこのアプリを作っています。",
  "api.make.tab5NoVersion": "そのバージョンはありません",

  // 部屋でアプリを作る (src/ui/make.ts, docs/make.md)。
  "make.dock.label": "エージェントとアプリを作る",
  "make.dock.send": "作る",
  "make.dock.for": "M5Stack Tab5 のアプリ",
  "make.dock.free": "無料で試せます。新しいアカウントには {n} クレジットが付きます",
  "make.credits": "クレジット: {n}",
  "make.loading": "少々お待ちください",
  "make.close": "閉じる",
  "make.failed": "うまくいきませんでした。もう一度お試しください。",
  "make.chat.label": "メーカーとの会話",
  "make.send": "送る",
  "make.send.price": "送る · {n}",
  "make.error.fix": "直す · {n}",
  "make.error.ignore": "無視する",
  "make.restart": "最初から",
  "make.fullscreen": "全画面",
  "make.tab5.on": "Tab5 のアプリ: 内容を書くと、エージェントが作ります",
  "make.tab5.example": "大きなボタンひとつの集中タイマー",
  "make.tab5.mine": "あなたの Tab5 のアプリ",
  "make.tab5.draft": "試しのビルドです。まだ保存されていません",
  "make.tab5.draft.short": "試し",
  "make.tab5.draft.step": "試しのビルドを画面に出しました。",
  "make.tab5.screen.starting": "アプリを起動しています",
  "make.tab5.input.first": "作りたいものを書いてください",
  "make.tab5.input.next": "変えたいところを書いてください",
  "make.tab5.error": "アプリでエラーが起きました: {message}",
  "make.tab5.new": "新しい Tab5 のアプリ",
  "make.tab5.hello": "Tab5 で何を作りたいか教えてください。ツールでも、おもちゃでも、ゲームでもかまいません。よこ向きのタッチ画面で、ボタンはありません。",
  "make.tab5.working": "エージェントがアプリを作っています。",
  "make.tab5.stop": "止める",
  "make.tab5.stopped": "エージェントは途中で止まりました。クレジットは戻しました。",
  "make.tab5.step.read": "{file} を読んでいます",
  "make.tab5.step.write": "{file} を書いています",
  "make.tab5.step.search": "コードを調べています",
  "make.tab5.step.docs": "PocketJS のドキュメントを読んでいます",
  "make.tab5.step.build": "アプリをビルドしています",
  "make.tab5.step.shot": "アプリを動かして確かめています",
  "make.tab5.step.run": "コマンドを実行しています",
  "make.tab5.step.save": "バージョンを保存しています",
  "make.tab5.saved": "バージョン {rev} を試せます。",
  "make.tab5.screen.empty": "エージェントがビルドすると、ここにアプリが出ます。",
  "make.tab5.version": "バージョン {rev}",
  "make.tab5.device": "Tab5 用にダウンロード",
  "make.tab5.device.lead": "画面に出ているもののパッケージです。Tab5 にインストールするファイルです。",
  "make.out": "これには {price} クレジットが必要で、残りは {balance} です。",
  "make.out.member": "メンバーには毎月 {n} クレジットが付きます。",
  "make.out.paused": "メンバーシップの受付が再開すると、クレジットが増やせるようになります。",
  "make.out.renews": "{date} にクレジットが補充されます。",

  // メーカーのランディングページ (web/make/index.html)。
};
